/* Run the genuine Customily product form in a dialog, scoped to this theme's edit route. */
(() => {
  const params = new URLSearchParams(location.search);
  const editing = document.documentElement.classList.contains('ph-edit-page');
  const cartPath = (window.Shopify?.routes?.root || '/') + 'cart';
  const getCart = async () => { const r = await fetch(cartPath + '.js',{cache:'no-store'}); if (!r.ok) throw Error('Cart unavailable'); return r.json(); };
  const signature = value => JSON.stringify(value.items.map(i=>({key:i.key,quantity:i.quantity,properties:i.properties})).sort((a,b)=>a.key.localeCompare(b.key)));
  if (!editing) {
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-ph-edit]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
      const url = new URL(link.href);
      if (url.origin !== location.origin || !url.pathname.includes('/products/') || !url.searchParams.has('customizationId')) return;
      event.preventDefault();
      if (document.querySelector('[data-ph-cart][aria-busy="true"]')) return;
      url.searchParams.set('ph_cart_edit','1'); url.searchParams.set('ph_line',link.dataset.lineKey); url.searchParams.set('variant',link.dataset.variant);
      location.assign(url.href);
    });
    return;
  }
  const mount = async () => {
    const product = document.querySelector('[data-product-featured]');
    const template = document.getElementById('PHCartEditor');
    if (!product || !template) { location.replace(cartPath); return; }
    const variants = JSON.parse(document.getElementById('PHProductVariants').textContent);
    try { const config=JSON.parse(product.dataset.productFeatured);config.enableHistoryState=false;product.dataset.productFeatured=JSON.stringify(config); } catch { /* Main product remains usable. */ }
    document.body.append(template.content.cloneNode(true));
    const dialog = document.querySelector('body > .ph-editor');
    const status = dialog.querySelector('[data-ph-editor-status]');
    const save = dialog.querySelector('[data-ph-editor-save]');
    const closes = dialog.querySelectorAll('[data-ph-editor-close]');
    dialog.querySelector('.ph-editor__content').append(product);
    const main = document.getElementById('MainContent');
    main.replaceChildren();
    dialog.showModal();document.documentElement.classList.add('ph-editor-open');
    window.dispatchEvent(new Event('resize'));
    let baseline, line, busy=false, invalid=false, completed=false, started=false, restored=!!window.phOptionsRestored, timer, selectedId, inputTimer, pendingUntil=0;
    const errorText='We could not safely save this edit. Return to your cart and review the items before trying again.';
    const form = () => product.querySelector('#customily-cart-btn')?.closest('form');
    const variant = () => variants.find(v=>String(v.id)===form()?.querySelector('[name="id"]')?.value);
    const sync = () => {
      const button=product.querySelector('#customily-cart-btn');
      if(line) form()?.querySelectorAll('[name="quantity"]').forEach(el=>el.value=String(line.quantity));
      const disabled=busy||invalid||Date.now()<pendingUntil||!line||!restored||!variant()?.available||!button||button.disabled||button.getAttribute('aria-busy')==='true';
      if(save.disabled!==disabled)save.disabled=disabled;
    };
    const setBusy = value => { busy=value;closes.forEach(b=>b.disabled=value);dialog.setAttribute('aria-busy',String(value));sync(); };
    const leave = () => { if(!busy)location.assign(cartPath); };
    closes.forEach(b=>b.addEventListener('click',leave));
    dialog.addEventListener('cancel',event=>{event.preventDefault();leave();});
    const settle=()=>{pendingUntil=Date.now()+650;save.disabled=true;clearTimeout(inputTimer);inputTimer=setTimeout(sync,700);};
    product.addEventListener('change',settle,true);
    product.addEventListener('input',settle,true);
    new MutationObserver(sync).observe(product,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-busy']});
    addEventListener('customily-options-loaded',()=>{restored=true;if(!invalid&&!busy)status.textContent='';sync();});
    addEventListener('customily-required-error',()=>{clearTimeout(timer);setBusy(false);status.textContent='Please complete the required options below.';});
    addEventListener('customily-starts-adding-to-cart',()=>{started=true;setBusy(true);status.textContent='Saving your design…';});
    addEventListener('customily-update-cart-item-completed',async()=>{
      completed=true;clearTimeout(timer);
      try {
        const current=await getCart();
        const others=baseline.items.filter(i=>i.key!==line.key);
        const replacements=current.items.filter(i=>!others.some(o=>o.key===i.key));
        if(replacements.length!==1||replacements[0].variant_id!==selectedId||replacements[0].quantity!==line.quantity||current.item_count!==baseline.item_count||!others.every(i=>current.items.some(j=>j.key===i.key&&j.quantity===i.quantity)))throw Error('Unexpected cart result');
        location.assign(cartPath);
      }catch{invalid=true;setBusy(false);status.textContent=errorText;}
    });
    addEventListener('customily-add-to-cart-completed',()=>{if(!completed){clearTimeout(timer);invalid=true;setBusy(false);status.textContent=errorText;}});
    save.addEventListener('click',async()=>{
      if(save.disabled||busy)return;
      setBusy(true);status.textContent='Saving your design…';
      try {
        const current=await getCart();if(signature(current)!==signature(baseline))throw Error('Cart changed');
        const button=product.querySelector('#customily-cart-btn');const selected=variant();
        if(!selected?.available||!button||button.disabled)throw Error('Editor unavailable');
        selectedId=selected.id;sync();started=false;button.click();
        setTimeout(()=>{if(!started&&!completed){clearTimeout(timer);setBusy(false);}},1500);
        timer=setTimeout(()=>{if(!completed){invalid=true;setBusy(false);status.textContent=errorText;}},60000);
      }catch{invalid=true;setBusy(false);status.textContent=errorText;}
    });
    try {
      baseline=await getCart();line=baseline.items.find(i=>i.key===params.get('ph_line'));
      if(!line||new URL(line.properties['_customily-customization-url']).searchParams.get('customizationId')!==params.get('customizationId'))throw Error('Original item missing');
      const matches=baseline.items.filter(i=>{try{return new URL(i.properties['_customily-customization-url']).searchParams.get('customizationId')===params.get('customizationId');}catch{return false;}});
      if(matches.length!==1||line.selling_plan_allocation||line.properties['_customily-upsell-main-id']||line.properties['_customily-upsell-id'])throw Error('Unsupported item');
      if(restored)status.textContent='';sync();
    }catch{invalid=true;status.textContent=errorText;sync();}
    try {
      const response=await fetch(cartPath,{cache:'no-store'});if(!response.ok)throw Error('Cart unavailable');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const background=doc.getElementById('MainContent');
      background?.querySelectorAll('script,dialog,iframe').forEach(el=>el.remove());
      if(background)main.innerHTML=background.innerHTML;
    }catch{ /* Editor can still work without the cart background. */ }
    setTimeout(()=>{if(!restored&&!invalid){invalid=true;status.textContent=errorText;sync();}},45000);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
})();
